<template lang="pug">
.input-checkbox
  input(
    :id="getInputId",
    type="checkbox",
    :class="{ error: isError }",
    v-bind="$attrs",
    :checked="checked",
    @change="$emit('change', $event.target.checked)"
  )
  label(:for="getInputId")
    i.icon.icon-checked.input-checkbox__icon(v-if="checked")
    span(v-html="label")
</template>

<script>
export default {
  name: "BaseCheckbox",

  inheritAttrs: false,

  model: {
    prop: "checked",
    event: "change",
  },

  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getInputId() {
      return `${this.$attrs.name ? this.$attrs.name : "input"}_${Math.random()}`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../style/base-checkbox.scss";
</style>
